import { z } from 'zod';

/**
 * Admin login form validation schema.
 * Email + password authentication.
 */
export const adminLoginFormSchema = z.object({
  email: z
    .string()
    .min(1, 'メールアドレスは必須です')
    .email('有効なメールアドレスを入力してください'),
  password: z.string().min(1, 'パスワードは必須です'),
});

export type AdminLoginFormData = z.infer<typeof adminLoginFormSchema>;
